import { useTranslation } from 'react-i18next';
import { Anchor, Skeleton, Text } from '@mantine/core';
import { useDisclosure } from '@mantine/hooks';
import { activeChannels } from '@/lib/priceAlert';
import { usePriceAlerts } from '@/hooks/usePriceAlert';
import { useProfile } from '@/hooks/useProfile';
import type { PriceAlertChannel } from '@/types/priceAlert';
import BestPriceAlertModal from '@/components/app/sell/BestPriceAlertModal';
import classes from './BestPriceAlertCard.module.css';

// Точка входа в подписку «лучшая цена продажи» одной строкой под заголовком «Продать» («Бюллетень»): без панели
// и рамки, чтобы не оттеснять предложения вниз. Включённая подписка называет каналы. Ошибку чтения не показываем:
// выключенный вид, функция не блокирует работу.
export default function BestPriceAlertCard() {
  const { t } = useTranslation();
  const { data: subscriptions, isLoading } = usePriceAlerts();
  const { data: profile } = useProfile();
  const [opened, { open, close }] = useDisclosure(false);

  if (isLoading) {
    return <Skeleton h={20} w={420} maw="100%" />;
  }

  const subs = subscriptions ?? [];
  const channels = activeChannels(subs);
  const active = channels.length > 0;

  const channelLabel = (channel: PriceAlertChannel): string =>
    channel === 'WHATSAPP' ? t('app.sell.priceAlert.whatsapp') : t('app.sell.priceAlert.email');

  return (
    <>
      <p className={classes.line}>
        <Text span fw={600} c="var(--mantine-color-text)">
          {active ? t('app.sell.priceAlert.cardTitleOn') : t('app.sell.priceAlert.cardTitleOff')}
        </Text>
        <span>{active ? channels.map(channelLabel).join(', ') : t('app.sell.priceAlert.cardSubtitleOff')}</span>
        <Anchor component="button" type="button" size="sm" fw={600} c="brand.7" underline="always" onClick={open}>
          {active ? t('app.sell.priceAlert.edit') : t('app.sell.priceAlert.configure')}
        </Anchor>
      </p>
      <BestPriceAlertModal opened={opened} onClose={close} subscriptions={subs} fallbackEmail={profile?.email ?? ''} />
    </>
  );
}
